import Vue from 'vue';
import App from './app.vue';
import router from './router.js';

// 全局引入Vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
import { Toast } from 'vant';
Vue.use(Toast);
import '@vant/touch-emulator';

// 获取序号的全局方法
import { getSerialNumber } from "@/utils/SerialNumberUtil";
Vue.prototype.getSerialNumber = getSerialNumber;

router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 向下进行
  next();
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
